import { SoaFrameworkPanel } from "../components/SoaFrameworkPanel";
import { StandardHeader, STANDARD_PAGE_LABELS } from "../components/standards/StandardHeader";

export function StatementOfApplicabilityPage() {
  return (
    <div className="page-pad">
      <StandardHeader
        frameworkId="iso27001"
        page={STANDARD_PAGE_LABELS.soa}
        subtitle="Decide which Annex A controls apply to your organisation, record why, and attach evidence."
      />
      <SoaFrameworkPanel frameworkId="iso27001" />
    </div>
  );
}
